import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.4fr]">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-question-answer-line text-sm" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">关于阅读、更新与下载</h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              这些是读者问得最多的问题。如果看完还有疑问，说明本站暂时没有覆盖到你的场景，后续整理内容时会
              一并补充说明。
            </p>
            <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-4">
              <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600">
                <i className="ri-lightbulb-line mt-0.5 text-base text-accent-600" aria-hidden="true"></i>
                小提示：先在上方作品库里把状态切到「已完结」，再用题材标签收窄范围，通常几步就能找到一部能一口气
                读完的作品。
              </p>
            </div>
          </div>

          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((faq, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={faq.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : idx)}
                      aria-expanded={isOpen}
                      aria-controls={`faq-panel-${idx}`}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                    >
                      <span className="flex items-start gap-3">
                        <span className="mt-0.5 font-heading text-sm text-primary-500">
                          Q{String(idx + 1).padStart(2, "0")}
                        </span>
                        <span className="text-sm font-medium text-foreground-900 md:text-base">{faq.q}</span>
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-400 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h3>
                  {isOpen && (
                    <div id={`faq-panel-${idx}`} className="px-4 pb-5 pl-[3.1rem] pr-6 md:px-5 md:pl-[3.6rem]">
                      <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}